<template>
  <Transition name="fade">
    <div
      class="fixed h-screen w-full inset-0  overflow-auto"
      v-if="showModalComputed"
    >
      <slot name="modalHeader"> </slot>
      <slot name="modalBody"></slot>
      <slot name="modalFooter"></slot>
    </div>
  </Transition>
</template>

<script>
export default {
  props: {
    showModal: {
      required: true,
      type: Boolean,
      default: false
    },
    enableEsc: {
      required: false,
      type: Boolean,
      default: true
    },
    fixOverflow: {
      required: false,
      type: Boolean,
      default: true
    }
  },
  computed: {
    showModalComputed: function() {
      return this.showModal;
    }
  },
  watch: {
    showModalComputed: {
      handler() {
        if (this.showModalComputed) {
          this.$emit("showModal", true);
          document.body.classList.add("overflow-hidden");
        } else {
          this.$emit("hideModal", true);
          if (this.fixOverflow) {
            document.body.classList.remove("overflow-hidden");
          }
        }
      },
      deep: true
    }
  },
  created() {
    if (this.enableEsc) {
      const handleEscape = e => {
        if (e.key === "Esc" || e.key === "Escape") {
          //this.showModal = false;
          this.$emit("closeModal", true);
        }
      };
      document.addEventListener("keydown", handleEscape);
      this.$once("hook:beforeDestroy", () => {
        document.removeEventListener("keydown", handleEscape);
      });
    }
  }
};
</script>